{
	"name": "@melonjs/debug-plugin",
	"version": "16.0.0",
	"description": "melonJS debug plugin",
	"homepage": "https://www.npmjs.com/package/@melonjs/debug-plugin",
	"type": "module",
	"keywords": [
		"2D",
		"HTML5",
		"javascript",
		"TypeScript",
		"es6",
		"Canvas",
		"WebGL",
		"WebGL2",
		"game",
		"engine",
		"debug",
		"browser"
	],
	"repository": {
		"type": "git",
		"url": "git+https://github.com/melonjs/melonJS.git",
		"directory": "packages/debug-plugin"
	},
	"bugs": {
		"url": "https://github.com/melonjs/melonJS/issues"
	},
	"license": "MIT",
	"author": "Olivier Biot (AltByte Pte Ltd)",
	"funding": "https://github.com/sponsors/melonjs",
	"engines": {
		"node": ">=24.0.0"
	},
	"types": "./build/index.d.ts",
	"exports": {
		".": "./build/index.js"
	},
	"files": [
		"build/",
		"debug-panel.png",
		"package.json",
		"README.md"
	],
	"peerDependencies": {
		"melonjs": ">=19.5.0"
	},
	"devDependencies": {
		"concurrently": "^9.2.1",
		"esbuild": "^0.27.3",
		"melonjs": "workspace:*",
		"tsconfig": "workspace:*",
		"tsx": "^4.21.0",
		"typescript": "^6.0.2"
	},
	"scripts": {
		"dev": "concurrently --raw \"pnpm build:watch\" \"pnpm tsc:watch\"",
		"build": "tsx scripts/build.ts && pnpm types",
		"build:watch": "tsx scripts/build.ts watch",
		"lint": "eslint src/**.js",
		"prepublishOnly": "pnpm clean && pnpm build",
		"clean": "tsx scripts/clean.ts",
		"types": "tsc --project tsconfig.build.json",
		"tsc:watch": "tsc --project tsconfig.build.json --watch --noUnusedParameters false --noUnusedLocals false --preserveWatchOutput"
	}
}
